import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { GenericErrorPage } from 'common';
import { fetchGenericError } from './GenericErrorPageSlice';
import { GenericErrorPageContentSelector } from './GenericErrorPageContentSelector';

export function useGenericErrorPage(): AbstractContentState<GenericErrorPage> {
    return useCmsContent(fetchGenericError, GenericErrorPageContentSelector);
}
